import { useContext, useEffect, useState } from 'react';
import { ContextProvider } from '../../ContextProvider';
import { getLayoutWidth } from '../layoutWidth';

export const computeScreenSizes = (width) => {
  const isMobile = width < 900;
  const isTablet = width >= 900;
  const isDesktop = width >= 1200;
  const isLargeDesktop = width >= 1920;
  const isExtraLargeDesktop = width >= 2560;

  return {
    isMobile,
    isTablet: isTablet && !isDesktop,
    isDesktop,
    isLargeDesktop,
    isExtraLargeDesktop,
    width,
  };
};

// Used for both SSR and the client's initial render so hydration matches.
// Must not read window — the server has no window, and the client must
// produce identical output on the first render to avoid hydration mismatch.
const getInitialScreenSizes = (deviceType) => {
  const width = deviceType === 'mobile' ? 600 : 1200;
  return computeScreenSizes(width);
};

const useScreenSize = () => {
  const context = useContext(ContextProvider);
  const [screen, setScreen] = useState(() => getInitialScreenSizes(context.deviceType));

  useEffect(() => {
    const handleResize = () => {
      setScreen(computeScreenSizes(getLayoutWidth()));
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Sync to the real window dimensions after hydration completes.
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return screen;
};

export default useScreenSize;
